export const REMOTE_REQUEST = 'REMOTE_REQUEST';
export const REMOTE_RESPONSE = 'REMOTE_RESPONSE';

export function remoteRequest(reqId, method, args, retry = true, activate = false) {
    return { type: REMOTE_REQUEST, reqId, method, args, retry, activate };
}

export function remoteResponse(reqId, response, error) {
    return { type: REMOTE_RESPONSE, reqId, response, error };
}
